import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {ROLES, SUB_ROLES, NO_SUB_ROLES} from '../../../reducers/account/role';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import './HomePage.css';
import CardWithLink from './cardWithLink/CardWithLink.container';
import {NOTIFICATION_TYPES} from "../../../constants/constants";
import SubRolesSwitch from '../subRolesSwitch/SubRolesSwitch.container';
import moment from "moment";
import {Alert} from "reactstrap";

class HomePage extends Component {
    componentWillMount() {
        this.getNotifications(this.props);
    }

    componentWillUpdate(nextProps) {
        if (this.props.loading && !nextProps.loading) {
            this.getNotifications(nextProps);
        }
    }

    getNotifications = (props) => {
        switch (props.role) {
            case ROLES.SYS_ADMIN:
                this.props.getSysAdminNotifications();
                break;
            case ROLES.EMPLOYEE:
                this.getEmployeeNotifications(props);
                break;
            case ROLES.APPLICANT:
                this.props.getApplicantNotifications();
                break;
            default:
                break;
        }
    };

    getEmployeeNotifications = (props) => {
        switch (props.currentSubRole) {
            case SUB_ROLES.INSERTER:
                this.props.getInsertorNotification();
                break;
            case SUB_ROLES.VALIDATOR:
                this.props.getValidatorNotifications();
                break;
            case SUB_ROLES.ANCHOR:
                this.props.getAnchorNotifications();
                break;
            default:
                break;
        }
    };

    render() {
        if (_.isNil(this.props.role)) {
            return null;
        }

        return (
            <div className="home-page-container">
                {this.renderWelcomeMessage()}
                {this.renderWarning()}
                {this.renderHint()}
                {this.renderContent()}
                {this.renderCommonData()}
            </div>
        );
    }

    renderContent = () => {
        switch (this.props.role) {
            case ROLES.SYS_ADMIN:
                return this.renderAdminHomePage();

            case ROLES.EMPLOYEE:
                return this.renderEmployeeHomePage();

            case ROLES.APPLICANT:
                return this.renderApplicantHomePage();

            default:
                break;
        }
    };

    renderWarning = () => {
        switch (this.props.currentSubRole) {
            case SUB_ROLES.ANCHOR:
                if (!_.isNil(this.props.paidTillDate) && moment(this.props.paidTillDate).isBefore(moment())) {
                    return (
                        <div className='warning-alert-container'>
                            <Alert color='danger' className='warning-alert'>
                                {_.get(this.props.translation, 'finance.pay_annual_license_alert')}
                            </Alert>
                        </div>
                    );
                }
                return;
            case SUB_ROLES.HM:
                if (!_.isNil(this.props.operationAvailability) && !this.props.operationAvailability.canCreateConsentRequest) {
                    return (
                        <div className='warning-alert-container'>
                            <Alert color='danger' className='warning-alert'>
                                {_.get(this.props.translation, 'finance.contact_anchor_alert')}
                            </Alert>
                        </div>
                    );
                }
                return null;
            default:
                return null;
        }
    };

    renderHint = () => {
        if (this.props.currentSubRole === SUB_ROLES.ANCHOR) {
            let validated = this.props.orgPermissions.validated;
            return (
                <div className='hint-alert-container'>
                    <Alert color={validated ? "success" : "warning"} className="hint-alert">
                        {_.get(this.props.translation, validated ? 'home.default_departments_hint' : 'home.not_validated_yet')}
                    </Alert>
                </div>
            );
        }
    }

    renderWelcomeMessage = () => {
        return (
            <div className="home-page-welcome">
                {_.get(this.props.translation, 'home.welcome_label')}
            </div>
        )
    };

    renderCommonData = () => {
        return (
            <div className="home-page-account-and-support">
                <h4>{_.get(this.props.translation, 'home.account_and_support_label')}</h4>
                <div className="home-page-cards-container">
                    <CardWithLink
                        icon="create"
                        tag="Link"
                        to="/account"
                        title={_.get(this.props.translation, 'account_management.label')}
                        text={_.get(this.props.translation, 'home.account_page_about')}
                    />
                    <CardWithLink
                        icon="info"
                        tag="a"
                        to="http://brainchainmission.org/user-forum-2"
                        title={_.get(this.props.translation, 'main.help_label')}
                        text={_.get(this.props.translation, 'home.support_page_about')}
                    />
                </div>
            </div>
        )

    };

    renderAdminHomePage = () => {
        if (this.props.loading || this.props.loadingNotifications) {
            return (
                <div className="loading-home-page-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            )
        }

        //TODO: change notifications for pending and validated ARR
        return (
            <div className="home-page-admin-page-container">
                {/* <h4>{_.get(this.props.translation, 'home.admin_pages_label')}</h4> */}
                <h4>{_.get(this.props.translation, 'main.organizations_select_button')}</h4>
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="admin-orgs-card"
                        icon="add"
                        to="/register-org"
                        title={_.get(this.props.translation, 'register_org.register_org_label')}
                        text={_.get(this.props.translation, 'home.register_org_page_about')}
                        hidden={!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA)}
                    />
                    <CardWithLink
                        tag="Link"
                        className="admin-orgs-card"
                        icon="create"
                        to="/organizations"
                        title={_.get(this.props.translation, 'main.orgs_page_button')}
                        text={_.get(this.props.translation, 'home.organizations_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="admin-orgs-card"
                        icon="check_box"
                        to="/validate-organizations"
                        notification={this.getNotificationByType(NOTIFICATION_TYPES.PENDING_ORGANIZATIONS)}
                        title={_.get(this.props.translation, 'main.validate_organizations_page_button')}
                        text={_.get(this.props.translation, 'home.validate_organizations_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="admin-orgs-card"
                        icon="lock"
                        to="/security"
                        notification={this.getNotificationByType(NOTIFICATION_TYPES.ADMIN_SECURITY_NOTIFICATIONS)}
                        title={_.get(this.props.translation, 'main.security_page_button')}
                        text={_.get(this.props.translation, 'home.security_page_admin_about')}
                        hidden={!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA)}
                    />
                </div>
                <h4 className={"home-page-admin-subtitle" + (!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA) ? ' hidden' : '')}>
                    {_.get(this.props.translation, 'main.payments_page_button')}
                </h4>
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="admin-payment-card"
                        icon="create"
                        to="/organizations-payments"
                        title={_.get(this.props.translation, 'main.orgs_payments_page_button')}
                        text={_.get(this.props.translation, 'home.orgs_payments_page_about')}
                        hidden={!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA)}
                    />
                    <CardWithLink
                        tag="Link"
                        className="admin-payment-card"
                        icon="create"
                        to="/commissions"
                        title={_.get(this.props.translation, 'main.commissions_list_page_button')}
                        text={_.get(this.props.translation, 'home.commissions_list_page_about')}
                        hidden={!this.props.subRoles.includes(SUB_ROLES.ROOT)}
                    />
                    <CardWithLink
                        tag="Link"
                        className="admin-payment-card"
                        icon="payment"
                        to="/due-payments"
                        title={_.get(this.props.translation, 'main.due_payments_page_button')}
                        text={_.get(this.props.translation, 'home.due_payments_page_about')}
                        hidden={!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA)}
                    />
                    <CardWithLink
                        tag="Link"
                        className="admin-payment-card"
                        icon="info"
                        to="/payments-history"
                        title={_.get(this.props.translation, 'main.payments_history_page_button')}
                        text={_.get(this.props.translation, 'home.payments_history_page_about')}
                        hidden={!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.FA)}
                    />
                </div>
                <h4 className={"home-page-admin-subtitle" + (!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA) ? ' hidden' : '')}>{_.get(this.props.translation, 'main.domains_page_button')}</h4>
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="admin-arr-card"
                        icon="check_box"
                        to="/pending-accreditation-requests-by-domains"
                        notification={this.getNotificationByType(NOTIFICATION_TYPES.UNREFERENCED_ACCREDITATION_REQUESTS_BY_DOMAINS)}
                        title={_.get(this.props.translation, 'main.pending_accreditation_requests_list_page_button')}
                        text={_.get(this.props.translation, 'home.pending_accreditation_requests_list_admin_page_about')}
                        hidden={!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA)}
                    />
                    <CardWithLink
                        tag="Link"
                        className="admin-arr-card"
                        icon="create"
                        to="/validated-domains"
                        title={_.get(this.props.translation, 'main.validated_accreditation_requests_list_page_button')}
                        text={_.get(this.props.translation, 'home.validated_accreditation_requests_list_admin_page_about')}
                        hidden={!this.props.subRoles.includes(SUB_ROLES.ROOT) && !this.props.subRoles.includes(SUB_ROLES.PA)}
                    />
                </div>
                <h4 className={"home-page-admin-subtitle" + (!this.props.subRoles.includes(SUB_ROLES.ROOT) ? ' hidden' : '')}>{_.get(this.props.translation, 'main.assistants_page_button')}</h4>
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="admin-assistants-card"
                        icon="create"
                        to="/assistants-management"
                        title={_.get(this.props.translation, 'main.assistants_page_button')}
                        text={_.get(this.props.translation, 'home.assistants_page_about')}
                        hidden={!this.props.subRoles.includes(SUB_ROLES.ROOT)}
                    />
                    <CardWithLink
                        tag="Link"
                        className="admin-assistants-card"
                        icon="create"
                        to="/business-ambassadors"
                        title={_.get(this.props.translation, 'main.business_ambassadors_page_button')}
                        text={_.get(this.props.translation, 'home.business_ambassadors_page_about')}
                        hidden={!this.props.subRoles.includes(SUB_ROLES.ROOT)}
                    />
                </div>
            </div>
        )
    };

    renderEmployeeHomePage = () => {
        return (
            <div className="home-page-employee-page-container">
                {this.renderSubRoleSelect()}
                {this.renderSubRoleData()}
            </div>
        )
    };

    renderSubRoleSelect = () => {
        if (this.props.subRoles && this.props.subRoles.length > 1 && this.props.role !== ROLES.SYS_ADMIN) {
            return (
                <div className="home-page-sub-role-select-container">
                    <h4 className="text-center">{_.get(this.props.translation, 'home.choose_role_label')}</h4>
                    <SubRolesSwitch/>
                </div>
            )
        }
    };

    renderSubRoleData = () => {
        if (this.props.loading || this.props.loadingNotifications) {
            return (
                <div className="loading-home-page-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            )
        }

        switch (this.props.currentSubRole) {
            case SUB_ROLES.ANCHOR:
                return this.renderAnchorData();
            case SUB_ROLES.INSERTER:
                return this.renderInserterData();

            case SUB_ROLES.VALIDATOR:
                return this.renderValidatorData();

            case SUB_ROLES.HM:
                return this.renderHMData();

            case SUB_ROLES.BO:
                return this.renderBOData();

            case NO_SUB_ROLES:
                return;

            default:
                break;
        }
    };

    renderAnchorData = () => {
        return (
            <div className="home-page-anchor-data-container">
                {this.props.subRoles && this.props.subRoles.length > 1 ? null :
                    <h4>{_.get(this.props.translation, 'home.anchor_pages_label')}</h4>}
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="anchor-card"
                        icon="info"
                        to="/payment"
                        title={_.get(this.props.translation, 'main.payment_label')}
                        text={_.get(this.props.translation, 'home.payment_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="anchor-card"
                        icon="create"
                        to="/org-settings"
                        title={_.get(this.props.translation, 'main.org_management_button')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="anchor-card"
                        icon="person"
                        to="/organization-staff"
                        title={_.get(this.props.translation, 'main.staff_members_page_button')}
                        text={_.get(this.props.translation, 'home.organization_staff_page_about')}
                    />
                    {(!_.isNil(this.props.orgPermissions) && this.props.orgPermissions.hasIVs) ?
                        <CardWithLink
                            tag="Link"
                            className="anchor-card"
                            icon="create"
                            to="/groups-management"
                            title={_.get(this.props.translation, 'main.groups_management_page_button')}
                        /> : null}
                    {(!_.isNil(this.props.orgPermissions) && !this.props.orgPermissions.hasIVs) ?
                        <CardWithLink
                            tag="Link"
                            className="anchor-card"
                            icon="create"
                            to="/groups-management"
                            title={_.get(this.props.translation, 'main.departments_page_button')}
                            text={_.get(this.props.translation, 'home.departments_page_about')}
                        /> : null}
                    {(!_.isNil(this.props.orgPermissions) && this.props.orgPermissions.hasIVs) ?
                        <CardWithLink
                            tag="Link"
                            className="anchor-card"
                            icon="create"
                            to="/accreditation-requests-by-group"
                            notification={this.getNotificationByType(NOTIFICATION_TYPES.UNREFERENCED_ACCREDITATION_REQUESTS_BY_AGS)}
                            title={_.get(this.props.translation, 'main.accreditation_requests_list_page_button')}
                            text={_.get(this.props.translation, 'home.accreditation_requests_list_anchor_page_about')}
                        /> : null}
                    {(!_.isNil(this.props.orgPermissions) && this.props.orgPermissions.hasIVs) ?
                        <CardWithLink
                            tag="Link"
                            className="anchor-card"
                            icon="lock"
                            to="/security"
                            notification={this.getNotificationByType(NOTIFICATION_TYPES.ANCHOR_SECURITY_GOT_IT)}
                            title={_.get(this.props.translation, 'main.security_page_button')}
                            text={_.get(this.props.translation, 'home.security_page_anchor_about')}
                        /> : null}
                </div>
            </div>
        );
    };

    renderInserterData = () => {
        return (
            <div className="home-page-inserter-data-container">
                {this.props.subRoles && this.props.subRoles.length > 1 ? null :
                    <h4>{_.get(this.props.translation, 'home.inserter_pages_label')}</h4>}
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="inserter-card"
                        icon="add"
                        to="/insert-accreditation"
                        title={_.get(this.props.translation, 'main.insert_accreditation_page_button')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="inserter-card"
                        icon="create"
                        to="/review-accreditations"
                        notification={this.getNotificationByType(NOTIFICATION_TYPES.REVIEW_FAILED_ACCREDITATIONS)}
                        title={_.get(this.props.translation, 'main.review_accreditations_page_button')}
                        text={_.get(this.props.translation, 'home.review_accreditations_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="inserter-card"
                        icon="add"
                        to="/bulk-accreditations-upload"
                        title={_.get(this.props.translation, 'main.bulk_jobs_list_page_button')}
                        text={_.get(this.props.translation, 'home.bulk_accreditations_upload_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="inserter-card"
                        icon="create"
                        to="/pending-accreditation-requests"
                        notification={this.getNotificationByType(NOTIFICATION_TYPES.PENDING_ACCREDITATION_REQUESTS)}
                        title={_.get(this.props.translation, 'main.pending_accreditation_requests_page_button')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="inserter-card"
                        icon="lock"
                        to="/security"
                        notification={this.getNotificationByType(NOTIFICATION_TYPES.INSERTER_SECURITY_NO_CERTIFICATE)}
                        title={_.get(this.props.translation, 'main.security_page_button')}
                        text={_.get(this.props.translation, 'home.security_page_inserter_about')}
                    />
                </div>
            </div>
        );
    };

    renderValidatorData = () => {
        return (
            <div className="home-page-validator-data-container">
                {this.props.subRoles && this.props.subRoles.length > 1 ? null :
                    <h4>{_.get(this.props.translation, 'home.validator_pages_label')}</h4>}
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="validator-card"
                        icon="check_box"
                        to="/validate-accreditations"
                        notification={this.getNotificationByType(NOTIFICATION_TYPES.VALIDATE_ACCREDITATIONS)}
                        title={_.get(this.props.translation, 'main.validate_accreditations_page_button')}
                        text={_.get(this.props.translation, 'home.validate_accreditations_page_about')}
                    />
                </div>
            </div>
        );
    };

    renderHMData = () => {
        return (
            <div className="home-page-hm-data-container">
                {this.props.subRoles && this.props.subRoles.length > 1 ? null :
                    <h4>{_.get(this.props.translation, 'home.hm_pages_label')}</h4>}
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="hm-card"
                        icon="add"
                        to="/credentials-verification-request"
                        title={_.get(this.props.translation, 'main.verification_request_page_button')}
                        text={_.get(this.props.translation, 'home.credentials_verification_request_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="hm-card"
                        icon="create"
                        to="/consent-requests"
                        title={_.get(this.props.translation, 'main.consent_requests_page_button')}
                        text={_.get(this.props.translation, 'home.consent_requests_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="hm-card"
                        icon="create"
                        to="/bulk-consent-requests"
                        title={_.get(this.props.translation, 'main.bulk_consent_requests_page_button')}
                        text={_.get(this.props.translation, 'home.bulk_consent_requests_page_about')}
                    />
                </div>
            </div>
        );
    };

    renderBOData = () => {
        return (
            <div className="home-page-bo-data-container">
                {this.props.subRoles && this.props.subRoles.length > 1 ? null :
                    <h4>{_.get(this.props.translation, 'home.bo_pages_label')}</h4>}
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="bo-card"
                        icon="create"
                        to="/consent-requests"
                        title={_.get(this.props.translation, 'main.consent_requests_page_button')}
                        text={_.get(this.props.translation, 'home.consent_requests_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="bo-card"
                        icon="create"
                        to="/bulk-consent-requests"
                        title={_.get(this.props.translation, 'main.bulk_consent_requests_page_button')}
                        text={_.get(this.props.translation, 'home.bulk_consent_requests_page_about')}
                    />
                </div>
            </div>
        );
    };

    renderApplicantHomePage = () => {
        if (this.props.loading || this.props.loadingNotifications) {
            return (
                <div className="loading-home-page-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            )
        }

        return (
            <div className="home-page-applicant-page-container">
                {/* <h4>{_.get(this.props.translation, 'home.applicant_pages_label')}</h4> */}
                <h4>{_.get(this.props.translation, 'main.applicant_accreditations_select_button')}</h4>
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="applicant-accreditations-card"
                        icon="create"
                        to="/certified-accreditations"
                        title={_.get(this.props.translation, 'main.certified_accreditations_page_button')}
                        text={_.get(this.props.translation, 'home.certified_accreditations_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="applicant-accreditations-card"
                        icon="check_box"
                        to="/pending-accreditations"
                        notification={this.getNotificationByType(NOTIFICATION_TYPES.PENDING_ACCREDITATIONS)}
                        title={_.get(this.props.translation, 'main.pending_accreditations_page_button')}
                        text={_.get(this.props.translation, 'home.pending_accreditations_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="applicant-accreditations-card"
                        icon="create"
                        to="/verified-identities"
                        title={_.get(this.props.translation, 'main.vids_page_button')}
                        text={_.get(this.props.translation, 'home.verified_identities_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="applicant-accreditations-card"
                        icon="create"
                        to="/self-study-books"
                        title={_.get(this.props.translation, 'main.self_study_books_page_button')}
                        text={_.get(this.props.translation, 'home.self_study_books_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="applicant-accreditations-card"
                        icon="create"
                        to="/accreditation-requests-list"
                        title={_.get(this.props.translation, 'main.accreditation_requests_list_page_button')}
                        text={_.get(this.props.translation, 'home.accreditation_requests_list_applicant_page_about')}
                    />
                </div>
                <h4 className="applicant-consents-title">{_.get(this.props.translation, 'main.applicant_consents_select_button')}</h4>
                <div className="home-page-cards-container">
                    <CardWithLink
                        tag="Link"
                        className="applicant-consents-card"
                        icon="create"
                        to="/prior-consents"
                        title={_.get(this.props.translation, 'main.prior_consents_page_button')}
                        text={_.get(this.props.translation, 'home.prior_consents_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="applicant-consents-card"
                        icon="check_box"
                        to="/pending-consents"
                        notification={this.getNotificationByType(NOTIFICATION_TYPES.PENDING_CONSENTS)}
                        title={_.get(this.props.translation, 'main.pending_consents_page_button')}
                        text={_.get(this.props.translation, 'home.pending_consents_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="applicant-consents-card"
                        icon="create"
                        to="/active-consents"
                        title={_.get(this.props.translation, 'main.active_consents_page_button')}
                        text={_.get(this.props.translation, 'home.active_consents_page_about')}
                    />
                    <CardWithLink
                        tag="Link"
                        className="applicant-consents-card"
                        icon="create"
                        to="/consents-history"
                        title={_.get(this.props.translation, 'main.consents_history_page_button')}
                        text={_.get(this.props.translation, 'home.consents_history_page_about')}
                    />
                </div>
            </div>
        )
    };

    getNotificationByType = (type) => {
        if (this.props.loadingNotifications || _.isNil(this.props.notifications)) {
            return null;
        }

        return {
            type: type,
            data: this.props.notifications[type]
        };
    }
}

HomePage.propTypes = {
    loading: PropTypes.bool,
    role: PropTypes.string,
    currentSubRole: PropTypes.string,
    subRoles: PropTypes.array,
    orgPermissions: PropTypes.object,
    translation: PropTypes.object.isRequired,
    loadingNotifications: PropTypes.bool,
    notifications: PropTypes.object,
    balance: PropTypes.object,
    consentRequestFee: PropTypes.object,
    paidTillDate: PropTypes.string,
    operationAvailability: PropTypes.object,
    getSysAdminNotifications: PropTypes.func.isRequired,
    getInsertorNotification: PropTypes.func.isRequired,
    getValidatorNotifications: PropTypes.func.isRequired,
    getApplicantNotifications: PropTypes.func.isRequired,
    getAnchorNotifications: PropTypes.func.isRequired
};

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/commonComponents/homePage/HomePage.js